<template>
  <v-form ref="loginForm" @submit.prevent="login">
    <v-card class="elevation-12">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Log In</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pb-0">
        <v-text-field id="username"
                      name="username"
                      label="Username"
                      ref="username"
                      outlined
                      v-model="username"
                      :rules="rules.username" />
        <v-text-field id="password"
                      name="password"
                      type="password"
                      label="Password"
                      ref="password"
                      outlined
                      v-model="password"
                      :error-messages="serverError"
                      :rules="rules.password"
                      @focus="serverError = ''" />
      </v-card-text>
      <v-card-actions class="px-4">
        <v-btn type="submit"
               color="primary"
               large ripple
               :loading="loading">Login</v-btn>
        <v-btn class="ml-auto"
               large ripple
               text link
               :to="{ name: 'forgot' }">Forgot Password</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { rules } from '@/util/Helpers';

export default {
  name: 'LoginForm',
  data() {
    return {
      rules: {
        username: [
          (v) => rules.required(v, 'Username is required'),
        ],
        password: [
          (v) => rules.required(v, 'Password is required'),
        ],
      },
      username: '',
      password: '',
      serverError: '',
      loading: false,
    };
  },
  methods: {
    async login() {
      if (this.$refs.loginForm.validate()) {
        this.loading = true;
        try {
          const result = await this.$store.dispatch('post', {
            api: '/Login',
            data: {
              grant_type: 'password',
              username: this.username,
              password: this.password,
            },
          });
          this.$store.dispatch('login', result);
          this.$router.push(this.$route.query.redirect || { name: 'home' });
        } catch (e) {
          this.serverError = e.response.data.error_description;
        }
        this.loading = false;
      }
    },
  },
};
</script>
